import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/actividades-de-contribuyentes/';

/**
 * GET Actividades de Contribuyentes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getActividadesDeContribuyente = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Actividades de Contribuyentes
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getActividadDeContribuyente = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Actividad de Contribuyente
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postActividadDeContribuyente = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Actividad de Contribuyente
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchActividadDeContribuyente = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Actividad de Contribuyente
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteActividadDeContribuyente = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
